import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20d6a9da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "login-left" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Add AI To Your App With One API", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Send Magic Link", -1))
const _hoisted_8 = {
  key: 0,
  class: "login-spinner"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "login-image.jpg",
    alt: "login",
    class: "login-image"
  })
], -1))

import { ref, computed } from "vue";
import { login as loginService } from "@/refs/account";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const showSpinner = ref<boolean>(false);
const userEmail = ref<string>("");
const router = useRouter();

const loginUser = async () => {
	try {
		showSpinner.value = true;
		await loginService(userEmail.value);
		router.push("/api");
	} catch (err) {
		console.warn(err);
	} finally {
		showSpinner.value = false;
	}
};
const logoPath = computed(() => {
	return document.body.getAttribute("data-mode") === "light"
		? "logoLightmode.svg"
		: "logo.svg";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(logoPath),
          alt: "logo",
          class: "logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            placeholder: "Enter your email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userEmail).value = $event))
          }, null, 512), [
            [_vModelText, userEmail.value]
          ]),
          _createElementVNode("button", {
            onClick: loginUser,
            class: "btn-primary"
          }, [
            _hoisted_7,
            (showSpinner.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _hoisted_9
  ]))
}
}

})